// extracted by mini-css-extract-plugin
export default {"acceptfood_container":"Accept-food-customer_acceptfood_container__OUpnO","food_add_form":"Accept-food-customer_food_add_form__XEgqH"};